import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from 'antd';
import styles from './style.module.less';
const AuthButton = ({ onClick, iconSrc, children, }) => {
    return (_jsxs(Button, { className: styles.button, onClick: onClick, children: [_jsx("img", { className: styles.logo, alt: "", src: iconSrc }), children] }));
};
export default AuthButton;
